/**
 * Manage error codes for client side "overwrites" using the createClientAppError function.
 */
export const ClientErrorCodes = {
  UPLOAD_TIMEOUT: 'UPLOAD_TIMEOUT',
  FILE_TOO_SMALL: 'FILE_TOO_SMALL',
  FILE_TOO_BIG: 'FILE_TOO_BIG',
  UNAUTHENTICATED: 'UNAUTHENTICATED',
  FORBIDDEN: 'FORBIDDEN',
  GATEWAY_TIMEOUT: 'GATEWAY_TIMEOUT',
};
